import './Encounter.css';
import { useState, useEffect } from "react";
import { encounter, formatDate } from '../../../service/constants';

const Encounter = (props) => {
    const [data, setData] = useState("")
    useEffect(() => {
        setData(props.getData())
    }, [data, props])

    const [selectedText, setselectedText] = useState("")

    return (
        <div className="encounterContainer">
            {data?.objects?.map((item, idx) => (
                <div className={`${selectedText=== idx?"active":""} cursor-pointer encounterItem`} key={idx} onClick={() => {
                    props.setResourceListData(item)
                    setselectedText(idx)
                    }}>
                    <span className={`encounterDate ${idx === data?.objects?.length - 1 ? 'lastRow' : ''}`}>
                        {formatDate(item?.resource?.period?.start)}
                    </span>
                    <span className={`${idx === data?.objects?.length - 1 ? 'lastRow' : ''} encounterText`}>
                        {encounter(item?.resource?.period?.start, item?.resource?.reasonCode[0]?.text)}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default Encounter;